import { useField } from 'formik';
import InputMask from 'react-input-mask';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';

/**
 * Stream-line solution for the formik validation fields
 * Base component for formik input fields with mask option
 */

const MaskedInput = ({
  label,
  append,
  name,
  mask,
  maskChar,
  maxLength,
  disabled = false,
  ...props
}) => {
  const [field, meta] = useField({ name, ...props });

  const TextFieldProps = {
    fullWidth: true,
    size: 'small',
    variant: 'outlined',
    type: props?.type || 'text',
    disabled: disabled,
    FormHelperTextProps: { className: 'mx-4 mt-2 text-12' },
    inputProps: { maxLength },
    error: meta && meta.touched && meta.error ? true : undefined,
    helperText: meta.touched && meta?.error && <> {meta.touched && meta?.error}</>
  };

  return (
    <>
      <InputLabel className="mb-8 text-gray-700 font-semibold"> {label}</InputLabel>
      <InputMask
        {...field}
        {...props}
        name={name}
        mask={mask}
        maskChar={maskChar}
        disabled={disabled}>
        {inputProps => <TextField {...inputProps} {...TextFieldProps} />}
      </InputMask>
    </>
  );
};

export default MaskedInput;
